import { HoldRequestDialogcomponent, HoldRequestDialogResultTypes } from '../../../dialogs/hold-request/hold-request-dialog.component';
import { MemberTypes } from '../../../models/ss-api/responses/login.response';
import { GlobalServices } from '../../../services/global.service';
import { BillingRecurringTypes, DashboardLicenseResponse, LicenseStatus, } from '../../../models/ss-api/responses/dashboard.license.response';
import { DashboardProductsResponse, IDashboardProductsResponse, } from '../../../models/ss-api/responses/dashboard.products.response';
import { HttpError } from '../../../models/errors/HttpError';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AddProductDialogComponent, IAddProductDialogModel } from 'app/dialogs/add-product/add-product-dialog.component';
import { AddGISDialogComponent } from 'app/dialogs/add-gis/add-gis-dialog.component';
import { UpgradeProductDialogComponent } from 'app/dialogs/upgrade-product/upgrade-product-dialog.component';
import { CDKeyReassignDialogComponent } from 'app/dialogs/cdkey-reassign/cdkey-reassign-dialog.component';
import { CancellationRequestDialogComponent } from 'app/dialogs/cancellation-request/cancellation-request-dialog.component';
import { YARDAddDialogComponent } from 'app/dialogs/yard-add/yard-add-dialog.component';
import Swal from 'sweetalert2';

import { SelectItem } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { GISBundleResponseArray } from 'app/models/ss-api/responses/gis.bundle.response';
import { PublicOrderProductsResponseArray } from 'app/models/ss-api/responses/public.order.products.response';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';
import { UpgradableProductsResponseArray } from '../../../models/ss-api/responses/upgradable.products.response';
import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { YARDCancellationRequestDialogComponent } from 'app/dialogs/yard-cancellation-request/yard-cancellation-request-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { PayInvoiceDialogComponent } from '../../../dialogs/pay-invoice/pay-invoice-dialog.component';
import * as moment from 'moment';
import { ReactivateLicenseDialogComponent } from '../../../dialogs/reactivate-license/reactivate-license-dialog.component';
import { CheckHoldEligibilityResponse } from '../../../models/ss-api/responses/check.hold.eligibility.response';
import { CreditCardResponse } from 'app/models/ss-api/responses/credit.card.response';
import { MemberProfile } from 'app/models/domain/member.profile';



class MemberLicenseItem {
  Member: DashboardProductsResponse;
  License: DashboardLicenseResponse;
}

@Component({
  selector: 'account-memberships-new',
  templateUrl: './memberships-new.component.html',
  styleUrls: ['./memberships-new.component.scss'],
  providers: [DialogService]
})

export class MembershipsNewComponent implements OnInit {
  @Output() emitNoLicence: EventEmitter<boolean> = new EventEmitter();
  @Output() emitRefreshProducts: EventEmitter<any> = new EventEmitter();
  @Output() emitOnlyPastDueProduct: EventEmitter<any> = new EventEmitter();

  // public
  @Input() Products: Array<DashboardProductsResponse> = new Array<DashboardProductsResponse>();
  @Input() ProductsExpanded: MemberLicenseItem[] = [];
  availableLicences: MemberLicenseItem[] = [];
  registeredLicences: MemberLicenseItem[] = [];
  cancelledLicences: MemberLicenseItem[] = [];
  IsMember: boolean = true;
  onlyPastDueProduct: MemberLicenseItem;

  @Input() IsBusy: boolean = false;

  @Input() IsTOS: boolean = false;
  @Input() IsDispute: boolean = false;
  @Input() HasCancelled: boolean = false;
  @Input() memberProfile: MemberProfile;
  @Input() isDesigner: boolean;

  // gis
  CreditCards: SelectItem[];

  // shared gis
  GISSharedBundle: GISBundleResponseArray;

  // individual gis
  GISIndividualBundle: GISBundleResponseArray;

  // products
  PublicOrderProducts: PublicOrderProductsResponseArray;

  // TEST VARIABLES
  hasYARD: boolean = false;

  @Input() HasPastDuePayments: boolean = false;

  showWelcomeBack: boolean = false;

  @Input() hasLicenseOnHold: boolean = false;

  @Input() hasLicenseScheduledToHold: boolean = false;

  @Input() heldLicense: DashboardLicenseResponse = null;

  HasDialog: boolean = false;

  licenseViewType: 'Available' | 'Registered' | 'Cancelled' = 'Available';
  licenseViewMode: 'List' | 'Grid' = 'List';
  scrollContainer: any;
  @ViewChild('tableFrame', { static: false }) tableFrame: ElementRef;

  showMore: boolean[][] = [];
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event']) onResize(e) {
    if (e.currentTarget.innerWidth <= 430) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  constructor(private router: Router, private route: ActivatedRoute, private dialogService: DialogService, private api: ssApiService, private gb: GlobalServices) {
    if (window.innerWidth <= 430) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    console.log("IsDevMode", gb.IsDevPublic());
    console.log("IsLocalMode", gb.IsLocal());
  }

  async ngOnInit() {
    this.showMore[0] = [];
    this.showMore[1] = [];
    this.showMore[2] = [];
    // this.route.queryParams.subscribe(response => {
    // 	console.log("PARAMS: ", response)
    // 	if(response.p && response.b) {
    // 		this.showAddDialog();
    // 	}
    // });

    this.CheckIsMember();

    this.CheckForWelcomeBack();

  }

  ngOnChanges() {
    if (this.ProductsExpanded && this.ProductsExpanded.length) {
      console.log("ProductsExpanded : ", this.ProductsExpanded);
      this.availableLicences = this.ProductsExpanded.filter(p => !p.License.IsRegistered && !this.IsCancelled(p) && p.License.Status != 99 && this.IsMember && !p.License.IsOnHold && !p.License.IsScheduledHold);
      this.registeredLicences = this.ProductsExpanded.filter(p => p.License.IsRegistered && !this.IsCancelled(p) && p.License.Status != 99 && !p.License.IsOnHold && !p.License.IsScheduledHold);
      this.cancelledLicences = this.ProductsExpanded.filter(p => this.IsCancelled(p) || p.License.IsScheduledHold || p.License.IsOnHold);
      console.log("availableLicences : ", this.availableLicences);
      console.log("registeredLicences : ", this.registeredLicences);
      console.log("cancelledLicences : ", this.cancelledLicences);
      if (!this.availableLicences.length && !this.registeredLicences.length && !this.cancelledLicences.length) {
        this.emitNoLicence.emit(true);
      }
      const pastDueProducts = this.ProductsExpanded.filter(p => p.License.Status != 99 && p.License.IsGrace);
      if (pastDueProducts.length === 1) {
        this.onlyPastDueProduct = pastDueProducts[0];
      }
      this.emitOnlyPastDueProduct.emit(this.onlyPastDueProduct);
    }
  }

  CheckForWelcomeBack() {

    let IsWelcomeBack: string = localStorage.getItem('WelcomeBack');

    if (IsWelcomeBack == '1') {
      this.showWelcomeBack = true;
      localStorage.removeItem('WelcomeBack');
    }
  }

  WelcomeBackOK() {
    this.showWelcomeBack = false;
  }


  CheckIsMember() {
    if (this.gb.MemberType == MemberTypes.Member)
      this.IsMember = true;
    else
      this.IsMember = false;
  }

  CanPurchaseGIS(member) {
    if (this.gb.MemberID != member.MemberID && !member.IsMember)
      return false;
    else
      return true;
  }


  Upgradable(license: DashboardLicenseResponse): boolean {

    if ((license.ProductName.slice(0, 5).toLowerCase() == 'vip3d' || license.ProductName == 'Vendor Package') && license.Recurring == BillingRecurringTypes.Yearly)
      // nothing to upgrade to
      return false;
    else
      return true;

  }

  ShowGetYard(item: MemberLicenseItem): boolean {

    if (!item.License.YardAvailable)
      return false;

    if (!item.License.YardVisiblePublic && (!this.gb.IsDevPublic() && !this.gb.IsLocal()))
      return false;

    if (item.License.HasYard)
      return false;

    if (!this.IsMember)
      return false;

    if (item.License.IsGrace || item.License.IsOnHold || item.License.IsScheduledHold)
      return false;

    if (this.IsCancelled(item))
      return false;


    // ok
    return true;

  }

  GetProductAssignedName(item: DashboardLicenseResponse, firstName: string, LastName: string): string {

    let nameMod: string = '';

    if (item.Status == LicenseStatus.Cancelled || item.Status == LicenseStatus.CancelledOpen)
      nameMod = '(Cancelled)';

    if (item.Status == LicenseStatus.Terminated)
      nameMod = '(Cancelled)';

    if (item.Status == LicenseStatus.Disabled)
      nameMod = '(Disabled)';

    if (!item.IsRegistered)
      nameMod = '(Not Assigned)';

    if (item.IsGrace)
      nameMod = '(PAST DUE)';

    // const colorClass = item.IsGrace ? ' class="red"' : '';
    const colorClass = ' class="red"';
    return firstName + ' ' + LastName + ' <small' + colorClass + '>' + nameMod + '</small>';

  }

  BillingRecurringToString(type: BillingRecurringTypes): string {

    switch (type) {
      case BillingRecurringTypes.Yearly:
        return 'Yearly';

      case BillingRecurringTypes.Monthly:
        return 'Monthly';

      default:
        return 'Unknown';
    }

  }

  ProductNameToClassName(product: string): string {

    product = product.toLowerCase();

    switch (product) {
      case 'vip3d':
        return 'vip3d';

      case 'vendor package':
        return 'vip3d';

      case 'vizterra':
        return 'vizterra';

      case 'pool studio':
        return 'poolstudio';

      default:
        return product;
    }

  }

  ProductNameToImageName(product: string): string {
    const pName = this.ProductNameToClassName(product);
    return `/assets/images/logos/logo-${pName}.png`
  }

  PopulateProducts(products: IDashboardProductsResponse) {

    // reset
    this.Products = new Array<DashboardProductsResponse>();

    // add the member or designer (root)
    this.Products.push(products);

    this.IsTOS = products.IsTOS;
    this.IsDispute = products.IsDispute;

    // in case we have designers
    if (products.Desginers != undefined)
      products.Desginers.forEach(x => {
        if (this.IsTOS) {
          x.IsTOS = true;
        }
        if (this.IsDispute) {
          x.IsDispute = true;
        }
        this.Products.push(x);
      });

    this.ProductsExpanded = [];
    this.Products.forEach(item => {
      if (item.Licenses) {
        item.Licenses.forEach(license => {
          let newItem = new MemberLicenseItem;
          newItem.Member = item;
          newItem.License = license;

          this.ProductsExpanded.push(newItem);
        });
      }


    });

    if (this.Products[0]) {
      this.Products.forEach((product) => {
        product.Licenses.forEach(function (license) {
          if ((license.Status == LicenseStatus.Cancelled || license.Status == LicenseStatus.Terminated || license.Status == LicenseStatus.CancelledOpen) && !license.IsGrace) {
            this.HasCancelled = true;
          }
        }, this);
      });
    }

    this.ProductsExpanded = this.SortByStatus(this.ProductsExpanded);

    this.UpdateHasPastDuePayments(this.ProductsExpanded);

    let productID = localStorage.getItem('cartProductID');
    let billingCycle = localStorage.getItem('cartBillingCycle');

    if (productID && billingCycle) {
      this.showAddDialog();
    }

  }

  RefreshProducts() {
    this.emitRefreshProducts.emit();

  }

  toggleMode(event) {
    let target = event.target;
    $(target).parents('div.Box').toggleClass('hasOverlay');
  }


  private RefreshPublicOrderProducts(): Promise<any> {

    if (this.PublicOrderProducts != undefined && this.PublicOrderProducts.length > 0)
      // we already have propducts
      return new Promise<any>((resolve, reject) => { resolve(this.PublicOrderProducts); });


    // get all products
    return this.api.ProductsOrderProducts()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return; // error

        // save
        this.PublicOrderProducts = response.Data;

        return response;
      });
  }


  showAddDialog() {

    this.IsBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) => {

        // 2d refresh products
        this.RefreshPublicOrderProducts()
          .then((response) => {
            this.GetCancelledLicense().then((license) => {
              if (this.HasCancelled && license) {
                const ref = this.dialogService.open(ReactivateLicenseDialogComponent, {
                  data: {
                    title: '',
                    License: license,
                    CreditCards: this.CreditCards,
                    CameFromAdd: true,
                    Products: this.PublicOrderProducts,
                    memberProfile: this.memberProfile
                  },
                  showHeader: false,
                  modal: false,
                  maskStyleClass: 'opened',
                  draggable: true,
                  keepInViewport: true
                });
                ref.onClose.subscribe(() => {
                  this.RefreshProducts();
                });
              } else {
                // show add dialog

                let data: IAddProductDialogModel = {
                  title: '',
                  subTitle: '',
                  CreditCards: this.CreditCards,
                  Products: this.PublicOrderProducts,
                  SelectedCreditCard: 0,
                  memberProfile: this.memberProfile
                }
                const ref = this.dialogService.open(AddProductDialogComponent, {
                  data,
                  showHeader: false,
                  modal: false,
                  maskStyleClass: 'opened',
                  draggable: true,
                  keepInViewport: true
                });
                ref.onClose.subscribe(() => {
                  this.RefreshProducts();
                });
              }

              this.IsBusy = false;
            }).catch(error => {
            });
          })
          .catch((error: HttpError) => {
            this.IsBusy = false;
          });

      })
      .catch((error: HttpError) => {
        this.IsBusy = false;
      });

  }

  private GetCancelledLicense(): Promise<DashboardLicenseResponse> {
    return new Promise((resolve, reject) => {
      let cancelledLicense;
      for (let k = 0; k < this.Products.length; k++) {
        if (this.Products[k] && this.Products[k].Licenses) {
          for (let i = 0; i < this.Products[k].Licenses.length; i++) {
            let license = this.Products[k].Licenses[i];
            if ((license.Status == LicenseStatus.Cancelled || license.Status == LicenseStatus.Terminated || license.Status == LicenseStatus.CancelledOpen) && !license.IsGrace && moment(license.NextBillingDate).isBefore(moment())) {
              cancelledLicense = license;
            }
          }
          setTimeout(() => {
            resolve(cancelledLicense);
          }, 250);
        }
      }

      setTimeout(() => {
        reject();
      }, 500);
    });
  }

  private GetGISSharedBundle(): Promise<any> {

    return this.api.GISSharedBundle()
      .toPromise()
      .then(response => {
        if (!response.Result)
          return; // error

        this.GISSharedBundle = response.Data;

        return response;
      });
  }

  private GetGISIndividualBundle(): Promise<any> {

    return this.api.GISIndividualBundle()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        this.GISIndividualBundle = response.Data;

        return response;
      });
  }

  private GetCreditCards(): Promise<any> {

    if (this.CreditCards != undefined && this.CreditCards.length > 0)
      // we already have credit cards
      return new Promise<any>((resolve, reject) => { resolve(this.CreditCards); });


    // get all credit cards
    return this.api.CreditCardGetAll()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return; // error

        // populate credit cards
        this.CreditCards = [];

        response.Data.forEach(card => {
          if (this.isExpired(card) && !card.IsDefault) {
            //skip this card
          }
          else {
            this.CreditCards.push(
              {
                label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                  ' - Last four: ' + card.LastFour +
                  ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                value: card.ID
              }
            );
          }
        });

        return response;
      });
  }

  isExpired(Item: CreditCardResponse): boolean {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();
    if (Item.ExpYear + 2000 < currentYear)
      return true;
    else if (Item.ExpYear + 2000 == currentYear && Item.ExpMonth < currentMonth)
      return true

    return false;
  }

  showAddGISDialog(cdKey: string) {
    this.IsBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) =>

        // 2d get gis individual bundle
        this.GetGISIndividualBundle()
          .then((response) => {

            // all data loaded
            // show dialog
            const ref = this.dialogService.open(AddGISDialogComponent, {
              data: {
                title: 'Personal',
                subTitle: this.gb.FirstName + ' ' + this.gb.LastName,
                CreditCards: this.CreditCards,
                SelectedCreditCard: 0,
                Bundle: this.GISIndividualBundle,
                CDKey: cdKey
              },
              modal: false,
              maskStyleClass: 'opened',
              draggable: true,
              keepInViewport: true
            });
            ref.onClose.subscribe(() => {
              this.RefreshProducts();
            });
            this.IsBusy = false;
          })
      )
      .catch((error: HttpError) => {
        this.IsBusy = false;
      });

  }

  showCDKeyReassignDialog(key: string, firstName: string, lastName: string, email: string, showDesigner?: boolean) {
    if (showDesigner == undefined) showDesigner = true;
    const ref = this.dialogService.open(CDKeyReassignDialogComponent, {
      data: {
        title: '',
        subTitle: '',
        message: '',
        LicenseKey: key,
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        ShowDesigner: showDesigner
      },
      modal: false,
      maskStyleClass: 'opened',
      draggable: true,
      keepInViewport: true
    });
    ref.onClose.subscribe(() => {
      this.RefreshProducts();
    });
  }

  ShowTosDialog() {
    Swal.fire(
      {
        title: 'We are unable to process your account request online.',
        text: 'Please contact our team at 702-433-0274 for assistance with your request.',
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'OK',
      }).then(() => { }, () => { });
  }

  AssignToThisUser(key: string) {
    this.IsBusy = true;

    let subscription = this.api.LicenseAssigToLoggedinUser(key).subscribe(
      async (response) => {

        subscription.unsubscribe();

        if (!response.Result) {
          xToastr.ShowToast(ToastrTypes.Error, 'Error', response.Message);
          this.IsBusy = false;
          return;
        } else {

          this.RefreshProducts();

          this.IsBusy = false;
          Swal.fire(
            {
              title: 'Success!',
              text: 'This License Key is now assigned to your account.',
              icon: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            }).then(() => { }, () => { });
        }

      },

      (error) => {
        xToastr.ShowToast(ToastrTypes.Error, 'Error', error);
        this.IsBusy = false;
      });


  }

  showReactivateCDKeyDialog(license: DashboardLicenseResponse, item?: any) {
    this.IsBusy = true;

    if (this.hasLicenseOnHold) {

      Swal.fire(
        {
          title: 'Cannot Reactivate Membership',
          text: 'Your account has a membership currently on hold. You may resume your held membership.',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'OK',
        }).then(() => {

        }, () => { });


      this.IsBusy = false;
      return;

    }

    this.GetCreditCards()
      .then((response) => {
        this.RefreshPublicOrderProducts().then((response) => {
          this.IsBusy = false;
          const ref = this.dialogService.open(ReactivateLicenseDialogComponent, {
            data: {
              title: '',
              License: license,
              CreditCards: this.CreditCards,
              Products: this.PublicOrderProducts,
              CameFromAdd: false,
              memberProfile: this.memberProfile,
              designerName: `${item.Member.FirstName} ${item.Member.LastName}`
            },
            showHeader: false,
            modal: false,
            maskStyleClass: 'opened',
            draggable: true,
            keepInViewport: true
          });
          ref.onClose.subscribe(() => {
            this.RefreshProducts();
          });
        });
      }, error => {
        this.IsBusy = false;
      });

  }

  CancelMembershipClick(License: DashboardLicenseResponse) {

    let useHold: boolean = true;

    if (useHold && !License.IsGrace) {

      this.IsBusy = true;


      this.api.CheckHoldEligibility(License.Key).subscribe(response => {
        console.log(response);
        this.IsBusy = false;

        if (response.Data.HoldEligible) {

          this.showHoldDialog(License, response.Data);

        } else {

          this.showCancelDialog(License);

        }
      });


    } else {
      this.showCancelDialog(License);
    }
  }


  showCancelDialog(License: DashboardLicenseResponse, isSecondStyle = false) {

    this.IsBusy = true;
    this.HasDialog = true;

    const ref = this.dialogService.open(CancellationRequestDialogComponent, {
      data: {
        title: 'Cancel',
        subTitle: '',
        message: '',
        License: License,
        isSecondStyle
      },
      modal: false,
      maskStyleClass: 'opened',
      draggable: true,
      keepInViewport: true
    });

    this.IsBusy = false;
    this.HasDialog = false;
    ref.onClose.subscribe(() => {
      this.RefreshProducts();
    })
  }

  ManageHoldClick(License: DashboardLicenseResponse) {

    this.IsBusy = true;

    this.api.CheckHoldEligibility(License.Key).subscribe(response => {
      this.IsBusy = false;
      if (response.Data.HoldEligible || response.Data.NotEligibleReason.includes('Product is already on hold')) {

        this.showHoldDialog(License, response.Data);

      }

    });
  }

  showHoldDialog(License: DashboardLicenseResponse, holdResponse: CheckHoldEligibilityResponse) {

    if (this.HasDialog) return;

    this.IsBusy = true;
    this.HasDialog = true;

    this.GetCreditCards().then((result) => {
      const ref = this.dialogService.open(HoldRequestDialogcomponent, {
        data: {
          License: License,
          CreditCards: this.CreditCards,
          HoldResponse: holdResponse,
          isMobile: this.isMobile
        },
        modal: false,
        maskStyleClass: 'opened',
        styleClass: 'hold-request-dlg-wrapper',
        draggable: true,
        keepInViewport: true
      });

      ref.onClose.subscribe((response) => {
        this.HasDialog = false;
        this.IsBusy = false;
        this.HandleHoldDialogResult(License, response);
      });
    });

  }


  HandleHoldDialogResult(License: DashboardLicenseResponse, result: HoldRequestDialogResultTypes) {

    console.log("hold dialog result :", result);

    switch (result) {
      case HoldRequestDialogResultTypes.cancelled:
        break;

      case HoldRequestDialogResultTypes.success:
        this.RefreshProducts();
        break;

      case HoldRequestDialogResultTypes.error:
        console.log("Hold Dialog encoutnered an error");
        break;

      case HoldRequestDialogResultTypes.showCancel:
        this.showCancelDialog(License, true);
        break;

      default:
        break;
    }

  }


  showAddYARDDialog(license: DashboardLicenseResponse) {

    this.IsBusy = true;

    this.GetCreditCards()
      .then((response) =>
        this.api.YardGetPricing(license.Key).toPromise().then(

          yardPrice => {

            if (!yardPrice.Result) {
              this.IsBusy = false;
              return;
            }

            const ref = this.dialogService.open(YARDAddDialogComponent, {
              data: {
                title: 'Add YARD',
                subTitle: '',
                CreditCards: this.CreditCards,
                SelectedCreditCard: 0,
                License: license,
                YardPricing: yardPrice.Data,
              },
              modal: false,
              maskStyleClass: 'opened',
              draggable: true,
              keepInViewport: true
            });
            ref.onClose.subscribe(() => {
              this.RefreshProducts();
            });
            this.IsBusy = false;

          })

      ).catch(error => {
        this.IsBusy = false;
      })


  }

  showCancelYARDDialog(License: DashboardLicenseResponse) {
    const ref = this.dialogService.open(YARDCancellationRequestDialogComponent, {
      data: {
        title: 'Cancel',
        subTitle: 'subTitle',
        message: '',
        License: License
      },
      modal: false,
      maskStyleClass: 'opened',
      draggable: true,
      keepInViewport: true
    });
    ref.onClose.subscribe(() => {
      this.RefreshProducts();
    });
  }


  private GetUpgradeProducts(licenseKey: string): Promise<any> {

    // get all credit cards
    return this.api.ProductsUpgradableProducts(licenseKey)
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return; // error


        return response;
      });
  }

  showUpgradeDialog(license: DashboardLicenseResponse) {


    this.IsBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) =>

        // 2d get upgrade product list
        this.GetUpgradeProducts(license.Key)
          .then((productsResponse: IBaseResponse<UpgradableProductsResponseArray>) => {
            const ref = this.dialogService.open(UpgradeProductDialogComponent, {
              data: {
                title: '',
                subTitle: '',
                message: '',
                upgradeProducts: productsResponse.Data,
                CreditCards: this.CreditCards,
                SelectedCreditCard: 0,
                LicenseKey: license.Key,
                CurrentProductBillingCycle: license.Recurring,
                LicenseObject: license
              },
              modal: false,
              maskStyleClass: 'opened',
              draggable: true,
              keepInViewport: true
            });
            ref.onClose.subscribe(() => {
              this.RefreshProducts();
            });

            this.IsBusy = false;
          })
      )
      .catch((error: HttpError) => {
        this.IsBusy = false;
      });

  }

  isVipMembership(item: DashboardLicenseResponse): boolean {
    if (item.ProductName == 'VIP3D' || item.ProductName == 'Vendor Package')
      return true;

    return false;
  }


  SortByStatus(sortThis: MemberLicenseItem[]): MemberLicenseItem[] {

    sortThis.sort((a, b) => a.License.Status - b.License.Status);

    return sortThis;
  }

  showPayInvoiceDialog(item: DashboardLicenseResponse) {

    if (!this.IsMember)
      return;

    this.GetCreditCards().then((response) => {
      const ref = this.dialogService.open(PayInvoiceDialogComponent, {
        data: {
          title: 'Cancel',
          subTitle: '',
          CreditCards: this.CreditCards,
          Invoice: item.GraceInvoice
        },
        modal: false,
        maskStyleClass: 'opened',
        draggable: true,
        keepInViewport: true
      });
      ref.onClose.subscribe(() => {
        this.RefreshProducts();
      });
    }).catch((error: HttpError) => {
      this.IsBusy = false;
    });


  }

  DaysRemaining(terminationDate: Date): number {
    let daysRemaining: number = 0;
    let date1 = new Date();

    let diffc = date1.getTime() - terminationDate.getTime();

    daysRemaining = Math.round(Math.abs(diffc / (1000 * 60 * 60 * 24)));

    return daysRemaining;
  }

  isAfter(date: string): boolean {
    return moment(date).isAfter(moment());
  }

  UpdateHasPastDuePayments(myProducts: MemberLicenseItem[]) {
    let hasPastDuePayments: boolean = false;

    myProducts.forEach(x => {
      if (x.License.IsGrace) {
        hasPastDuePayments = true;
      }
    });

    this.HasPastDuePayments = hasPastDuePayments;
  }

  IsCancelled(myLicense: MemberLicenseItem): boolean {
    let isCancelled: boolean = false;

    let myStatus: LicenseStatus = myLicense.License.Status;

    if (!myLicense.License.IsGrace)
      if (myStatus == LicenseStatus.Cancelled
        || myStatus == LicenseStatus.CancelledOpen
        || myStatus == LicenseStatus.Disabled
        || myStatus == LicenseStatus.DoesNotExist
        || myStatus == LicenseStatus.Terminated)
        isCancelled = true;

    return isCancelled;
  }


  // Check and return if Member on License is a TOS offender OR Former TOS Offender
  IsTOSMember(item: MemberLicenseItem): boolean {

    let isTOS: boolean = false;

    if (item.Member.IsTOS || item.Member.IsFormerTOS || this.Products[0].IsFormerTOS || this.Products[0].IsTOS)
      isTOS = true;

    return isTOS;

  }

  licenseViewTypeChange(viewType) {
    let top = 0;
    this.licenseViewType = viewType;
    if (this.licenseViewType === 'Available') {
      top = 0;
    } else if (this.licenseViewType === 'Registered') {
      top = document.getElementById('origin-position').scrollHeight;
    } else if (this.licenseViewType === 'Cancelled') {
      top = document.getElementById('origin-position').scrollHeight + document.getElementById('registered-frame').scrollHeight;
    }
    const absoluteY = this.tableFrame.nativeElement.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    window.scrollTo({
      top: top + absoluteY,
      left: 0,
      behavior: 'smooth'
    });
  }

  licenseViewModeChange(viewMode) {
    this.licenseViewMode = viewMode;
  }

  toggleShowMore(type: number, i: number) {
    this.showMore[type][i] = !this.showMore[type][i];
  }

  isPastDue(Item) {
    return Item.License.Status != 99 && Item.License.IsGrace && !this.onlyPastDueProduct;
  }

}
